export default "__VITE_ASSET__feaa3397__"